<div class="left-container">
  <ng-container [ngTemplateOutlet]="iconTemplate"></ng-container>
</div>
<div class="content-container"><ng-content></ng-content></div>
<div class="right-filler"></div>
